/*
 * Main and demo navigation arrays
 *
 * 'to' attribute points to the route name, not the path url
 */

import { Roles } from "@/data/consts.js";

export default {
  main: [
    {
      name: "dashboard",
      to: "backend-dashboard",
      icon: "si si-speedometer",
      roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.DEALER_ADMIN]
    },
    {
      name: "mailsms",
      to: "mailsms",
      icon: "fa fa-comment-sms",
      roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.DEALER_ADMIN]
    },
    {
      name: "dealers",
      to: "dealers",
      icon: "far fa-building",
      roles: [Roles.SUPER_ADMIN, Roles.ADMIN]
    },
    {
      name: "customers",
      to: "customers",
      icon: "fa fa-industry",
      roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.DEALER_ADMIN]
    },
    {
      name: "applications",
      to: "applications",
      icon: "fa fa-hard-drive",
      roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.DEALER_ADMIN]
    },
    {
      name: "documents",
      to: "documents",
      icon: "fa fa-file-lines",
      roles: [Roles.SUPER_ADMIN, Roles.ADMIN]
    },
    {
      name: "chat_ai",
      to: "backend-ai-chat",
      icon: "fa fa-robot",
      roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.DEALER_ADMIN]
    },
    {
      name: "settings",
      to: "settings",
      icon: "si si-settings",
      roles: [Roles.SUPER_ADMIN]
    },
  ]
};
